import React, { useState } from "react";
import { Form, Formik } from "formik";
import { Container, Box } from "@mui/material";
import EmailInput from "components/atoms/EmailInput";
import * as yup from "yup";
import PostService from "utility/postService";
import DataLayerService from "utility/dataLayerService";
import { LeafButton } from "components/atoms/LeafButtons";
import Validation from "utility/validation";
import AlertMessage from "components/atoms/AlertMessage";
import "./style.scss";

const SignUp = (props) => {
  const location = "sign-up-form";
  const [showThankYou, setShowThankYou] = useState(false);
  const [email, setEmail] = useState('');
  const title = props.dataSet?.title ? props.dataSet.title : "Get 15% off our signature gutter protection";
  const description = props.dataSet?.description ? props.dataSet.description : "Subscribe to our mailing list and get 15% off your LeafFilter® purchase.";
  const form = props.dataSet?.form ? props.dataSet.form : "modal";
  let errorMsg = "";
  let emailAddress = '';

  const ValidationSchema = yup.object().shape({
    emailAddress: yup
      .string()
      .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, 'Please enter a valid email address.')
      .required("Email Address is required.")
  });

  const handleOnFocus = () => {
    // Passing lf.form.start event to DataLayer.
    DataLayerService.formStartEvent('standard', 'sign-up-form');

    // Passing lf.form.interaction event to DataLayer.
    DataLayerService.formInteractionEvent('standard', 'sign-up-form');
  };

  const handleOnBlur = (event) => {
    switch (event.target.name) {
      case 'emailAddress':
        emailAddress = event.target.value;
        break;

      default:
        break;
    }

    // Passing lf.form.interaction event to DataLayer.
    DataLayerService.formInteractionEvent(form, location);
  };

  const buttonSubmit = (e) => {
    const EmailValidation = Validation.EmailDataLayerValidation(emailAddress);

    // Validation Error.
    const validationError = {
      ...EmailValidation,
    };

    if (Object.keys(validationError).length !== 0) {
      DataLayerService.formFailEvent(form, location, validationError);
    }
  }

  return (
    <Formik
      initialValues={{
        emailAddress: '',
      }}
      validationSchema={ValidationSchema}
      onBlur={
        (event) => { handleOnBlur(event) }
      }
      onSubmit={async (values, actions) => {

        let submittedValues = {};
        try {
          const args = {
            "email": values.emailAddress,
            "leafhomeSignUp": 'enable',
          };
          // Generate Marketo Lead.
          const response = await PostService.formAbandonment('form-abandonment-lead', args);

          if (response.success) {
            setShowThankYou(true);

            // After successful submit, clear the field
            setEmail('');
          }

          // Passing lf.form.start event to DataLayer.
          DataLayerService.formSuccessEvent(form, location, submittedValues);
        } catch (error) {
          console.log(error);
          console.log("Error in sending data");
        }
      }}
    >
      {({ handleSubmit, isSubmitting, values }) => (
        <Container>
          <div className="leaf-home-signup-wrap leafhome-forms">
            <div className="leaf-home-signup-inner-wrap">
              <h2 className="text-center display-4">{title}</h2>
              {description ?
                <p className="text-center h4 m-0 fw-normal py-5"> {description}</p>
              : ''}

              <Container disableGutters={true} maxWidth={"sx"} sx={{
                maxWidth: "400px"
              }}>
                <Form
                  onSubmit={handleSubmit}
                  onFocus={
                    () => { handleOnFocus() }
                  }
                  className="lhws-signup-form leaffilter-forms p-0"
                >
                  {errorMsg ? (<AlertMessage message={errorMsg} severity={'error'} />) : ""}
                  <Box className="form-inner-wrapper" display="flex" alignItems="baseline" sx={{ gap: 2 }}>
                    <div style={{ flexGrow: 1 }}>
                      <EmailInput
                        fieldName="emailAddress"
                        placeholder="Enter your email"
                        label={" "}
                        style={{
                          border: "1px solid #ADB5BD",
                          borderRadius: "8px",
                        }}
                        value={email}
                        boxStyle={{
                          marginBottom: 0,
                          width: "100%",
                        }}
                      />

                      {showThankYou && (
                        <div className="flex items-center gap-2 mt-2" aria-live="polite" style={{
                          marginTop: "4px",
                          fontWeight: "400",
                        }}>
                          <svg
                            width="21"
                            height="20"
                            viewBox="0 0 21 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17.1668 5L8.00016 14.1667L3.8335 10"
                              stroke="#198754"
                              strokeWidth="1.66667"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          <span>Thanks for subscribing!</span>
                        </div>
                      )}
                    </div>

                    <LeafButton
                      type="submit"
                      name="submit"
                      buttonClass="rounded-3 btn-primary fw-semibold"
                      handleClick={buttonSubmit}
                      isSubmitting={isSubmitting}
                    >
                      {isSubmitting ? "Submitting" : "Sign up"}
                    </LeafButton>
                  </Box>


                </Form>
              </Container>

            </div>
          </div>
        </Container>
      )}
    </Formik>
  )
}

export default SignUp;
